/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tall_Slim_Stork_WalkInputs */

const en_tall_slim_stork_walk = /** @type {(inputs: Tall_Slim_Stork_WalkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Added user`)
};

const de_tall_slim_stork_walk = /** @type {(inputs: Tall_Slim_Stork_WalkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer hinzugefügt`)
};

/**
* | output |
* | --- |
* | "Added user" |
*
* @param {Tall_Slim_Stork_WalkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tall_slim_stork_walk = /** @type {((inputs?: Tall_Slim_Stork_WalkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tall_Slim_Stork_WalkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tall_slim_stork_walk(inputs)
	return de_tall_slim_stork_walk(inputs)
});